module.exports = __webpack_public_path__ + "img/hr-red-desert-1.9162978c.png";